
import { WIZ_COMMAND_HTTP_METHOD, WIZ_COMMAND_RESPONSE_TYPE } from '@wizeoo/akm-core-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { BaselineValue } from '@wizeoo/akm-message-lib';
import { ConnectVO } from '../../vo/core/connect.vo';

/**
 * values I => S
 * Author LMA
 */
export class BaselinevalueBulkerCmd extends WizCommand<any> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public cnx:ConnectVO; // éventuelle fonction connect à l'origine de l'appel

  /** 
   * Appel connect depuis un grid / formulaire FreedataValue
   * @param connectAction 
   * @param FreeDataVO 
   * @param FreedataValueVO 
   * @returns 
   */
  public bulk(blvs: BaselineValue[], callback: Function, cnx:ConnectVO = null): BaselinevalueBulkerCmd {
    this.cnx = cnx;  
    this.configureRemote(ExternalAPI.BASELINE_VALUE_BULKER, blvs, callback, 
      WIZ_COMMAND_HTTP_METHOD.POST, WIZ_COMMAND_RESPONSE_TYPE.JSON, true, true);
    return this;
  }
  
}
